import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const SHOP = {
  name: "FONZ FIX4U",
  phoneDisplay: "07864 547992",
  phoneTel: "+447864547992",
  whatsapp: "447864547992",
  address: "47 Market Square, Dungannon, Co. Tyrone",
  mapEmbed: "https://www.google.com/maps?q=47+Market+Square,+Dungannon,+Co.+Tyrone&output=embed",
  photo: "/shop-front.jpg",
  mapLink: "https://www.google.com/maps/search/?api=1&query=47+Market+Square+Dungannon+Co.+Tyrone",
};

export const waLink = (text) => `https://wa.me/${SHOP.whatsapp}?text=${encodeURIComponent(text)}`;

export const formatPrice = (p) => (p == null ? null : `£${Number(p).toLocaleString("en-GB", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`);

export const productMessage = (p) => {
  const bits = [p.condition, p.storage, p.colour].filter(Boolean).join(", ");
  const price = formatPrice(p.price);
  return `Hi FONZ FIX4U, I'm interested in the ${p.name}${bits ? ` (${bits})` : ""}${price ? ` listed at ${price}` : ""}. Is it still available?`;
};

export const CATEGORIES = [
  { value: "all", label: "All" },
  { value: "iphone", label: "iPhone" },
  { value: "samsung", label: "Samsung" },
  { value: "tablet", label: "Tablets" },
  { value: "accessory", label: "Accessories" },
];

export const REPAIR_SERVICES = [
  "Screen replacement",
  "Battery replacement",
  "Charging port repair",
  "Tablet repair",
  "Laptop repair",
  "Something else",
];

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const imgSrc = (url) => (url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

// Staff sessions: silently refresh the short-lived access cookie once on 401, then retry.
let refreshing = null;
http.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status !== 401 || cfg._retried || url.startsWith("/auth/")) throw error;
    cfg._retried = true;
    refreshing = refreshing || http.post("/auth/refresh").finally(() => { refreshing = null; });
    await refreshing;
    return http(cfg);
  }
);

export const money = (v) => (v == null ? "—" : `£${Number(v).toFixed(2)}`);

export const PART_CATEGORIES = ["Screens", "Batteries", "Charging ports", "Back glass / housings", "Cameras", "Speakers & mics", "Buttons & flex cables", "Tablet parts", "Laptop parts", "Tools & adhesives", "Other"];
